<script>
import ModernInput from '@/components/ModernInput.vue';
import ModernSelect from '@/components/ModernSelect.vue';
import ModernSelectBox from '@/components/ModernSelectBox.vue';
import W9TaxForm from '@/components/Modal/W9TaxForm.vue';
import CustomerForm from '@/views/Manage/Users/components/CustomerForm.vue';
import { DialogProgrammatic as Dialog } from 'buefy';
import { confirmAccount, createUser } from '@/api/user';
import {
  contractors, getLeadSources, mergeLeads,
} from '@/api/contractor';
import { searchOne as getManager } from '@/api/manager';
import { mapGetters, mapMutations, mapState } from 'vuex';
import {
  get, set, omit, pick, template,
} from 'lodash';
import * as MUTATIONS from '@/store/mutations';
import * as ACTIONS from '@/store/actions';
import Vue from 'vue';
import { getLeadFirstTouch } from '@/api/settings';
import Lead from '@/components/Modal/Lead.vue';
import Notification from '@/components/Notification.vue';
import ModernTable from '@/components/ModernTable.vue';
import { getBusinessTypes, getSpecializations } from '@/api/customer';
import ReportsTableTooltip from '@/components/Widgets/ReportsTableTooltip.vue';

export default {
  name: 'UserCustomers',
  components: {
    ReportsTableTooltip,
    ModernTable,
    ModernSelectBox,
    ModernSelect,
    ModernInput,
  },

  data() {
    const help = {
      type: `The field shows the customer category: Contractor, Medical, or General.<br>
      If the customer type differs from the business type, the business type is also displayed.`,
    };

    return {
      customerTypeOptions: [],
      paymentStatusOptions: [
        { value: '', label: '' },
        { value: 'Paid', label: 'Paid' },
        { value: 'Canceled', label: 'Canceled' },
        { value: 'Failed', label: 'Failed' },
        { value: 'Renewed', label: 'Renewed' },
        { value: 'Unpaid', label: 'Unpaid' },
      ],
      w9Options: [
        { value: '', label: '' },
        { value: 'Not found', label: 'Not found' },
        { value: 'Pending', label: 'Pending' },
        { value: 'Verified', label: 'Verified' },
        { value: 'Rejected', label: 'Rejected' },
      ],
      tierOptions: [
        { value: '', label: '' },
        { value: 'Pro', label: 'Pro' },
        { value: 'Self', label: 'Self' },
        { value: 'Concierge', label: 'Concierge' },
        { value: 'Brand', label: 'Brand' },
        { value: 'Free', label: 'Free' },
        { value: 'Test', label: 'Test' },
      ],
      cpActivationOptions: [
        { value: '', label: '' },
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
        { value: 'Error', label: 'Error' },
      ],

      filters: {
        searchText: '',
        showDifferencesOnly: '',
        statusW9: '',
        statusPayment: '',
        typeId: null,
        tier: '',
        cpActivation: '',
        page: 1,
        limit: 25,
        sortField: 'hasUser',
        sortOrder: 'asc',
      },

      errorContent: '',
      isErrorActive: false,
      isMergeFormActive: false,
      mergeForm: {
        leadId1: null,
        leadId2: null,
      },

      loading: false,
      fixedHeader: false,
      stripWidth: 0,
      scroll: 0,
      total: 0,
      perPageOptions: [{ value: 10 }, { value: 25 }, { value: 50 }, { value: 100 }],
      isLeftSticky: false,
      isTopSticky: false,

      currentEditRow: null,
      hasError: false,
      data: [],
      help,
      columns: [
        {
          field: 'hasUser',
          label: 'Switch to',
          headerClass: 'switch-to-header',
          sticky: true,
          width: 100,
        },
        {
          field: 'companyName',
          label: 'Company name',
          headerClass: 'company-name-header',
          sortable: true,
          sticky: true,
          width: 300,
        },
        {
          field: 'firstName',
          label: 'First name',
          sortable: true,
          width: 250,
          sticky: true,
        },
        {
          field: 'lastName', label: 'Last name', sortable: true, width: 250, sticky: true,
        },
        {
          field: 'email', label: 'E-mail', sortable: true, width: 450,
        },
        {
          field: 'phoneNumber', label: 'Phone number', sortable: true, width: 170,
        },
        {
          field: 'contractorPlan', label: 'Plan', sortable: true, width: 320,
        },
        {
          field: 'registrationDate', label: 'Registration date', sortable: true, width: 160,
        },
        {
          field: 'cpActivation', label: 'CP activation', sortable: true, width: 160,
        },
        {
          field: 'type', label: 'Type', sortable: true, width: 160, meta: help.type,
        },
        {
          field: 'lead', label: 'Lead', sortable: true, width: 550,
        },
        {
          field: 'paymentStatus', label: 'Payment Status', sortable: true, width: 150,
        },
        {
          field: 'w9', label: 'W-9', sortable: true, width: 160,
        },
        {
          field: 'contractorId', label: 'Customer ID', sortable: true, width: 160,
        },
        { field: '', label: '', width: 150 },
      ],
    };
  },

  async activated() {
    this.fixedHeader = false;
    await this.search();
  },

  async mounted() {
    if (this.$route.query.companyName) {
      this.filters.searchText = this.$route.query.companyName;
      await this.search();
    } else {
      await this.search();
    }

    this.customerTypeOptions = [{ id: null, value: '' }, ...this.customerTypes];
  },

  watch: {
    queryParams() {
      this.filters.page = 1;
      this.search();
    },

    pageOrderParams() {
      this.search();
    },
  },

  computed: {
    ...mapState('user', {
      userId: (state) => state.id,
    }),
    ...mapState('auth2', {
      userAuthEmail: (state) => state.email,
    }),
    ...mapGetters(['isSwitched', 'authAuthenticator']),
    ...mapState({ windowWidth: (state) => state.windowWidth }),
    ...mapState('constant', ['customerTypes']),

    pageOrderParams() {
      return JSON.stringify(pick(this.filters, ['page', 'sortOrder', 'sortField']));
    },

    queryParams() {
      return JSON.stringify(omit(this.filters, ['searchText', 'page', 'sortOrder', 'sortField']));
    },
  },

  methods: {
    get, // shortand lodash _.get declaration
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),

    cpActivationTitle(row) {
      if (get(row, 'cpActivation.date')) {
        return this.$options.filters.dateFormat(get(row, 'cpActivation.date'));
      }
      return get(row, 'cpActivation.error', '');
    },

    isCreateAccountAvailable(record) {
      return !record.hasUser
        && record.paymentStatus === 'Paid'
        && this.authAuthenticator({ resource: 'manage-contractors', code: 'account_create' });
    },

    isSendConfirmEmailAvailable(record) {
      return record.hasUser && (record.cpActivation.length === 0 || record.cpActivation.error);
    },

    w9Status(row) {
      return get(row, 'w9Tax.status', '');
    },

    extractW9Options(rowData) {
      const w9Tax = rowData.w9Tax ?? {};
      return {
        fullName: w9Tax.fullName ?? '',
        companyName: w9Tax.companyName ?? '',
        status: w9Tax.status ?? 'Not Found',
        isSSN: w9Tax.isSSN,
        isEIN: w9Tax.isEIN,
        isDifferent: w9Tax.isDifferent,
        skipDifferences: w9Tax.skipDifferences,
        danger: Boolean(w9Tax.status && w9Tax.isDifferent && !w9Tax.skipDifferences),
      };
    },

    async clearPageSearch() {
      this.filters.page = 1;
      await this.search();
    },

    async search(scrollToTop = true) {
      this.loading = true;
      try {
        const { data } = await contractors({
          ...this.filters,
          userId: this.isSwitched ? this.userId : null,
        });
        this.data = data.data;
        this.total = data.total;
        this.sortByChecked();
      } catch (error) {
        Dialog.alert({
          message: `${error.message}<br/>Error: loading`,
          type: 'is-danger',
          title: 'Error',
        });
      } finally {
        setTimeout(() => {
          if (scrollToTop) {
            if (this.$refs.table) {
              this.$refs.table.scrollTop();
            }
          }
          this.loading = false;
        }, 200);
      }
    },

    sortByChecked() {
      const checkedRows = this.data.filter((row) => row.user === this.userId);
      checkedRows.forEach((row) => {
        this.data.splice(this.data.indexOf(row), 1);
        this.data.unshift(row);
      });
    },

    async switchTo(value, checked) {
      const userId = checked ? value : this.$store.state.auth2.id;
      this.$store.commit(MUTATIONS.SET_SPLASH, true);

      try {
        await this.$store.dispatch(ACTIONS.SWITCH_USER, userId);
        this.sortByChecked();
        await this.$router.replace('/');
      } catch (err) {
        Dialog.alert({
          message: `${err.message}<br/>Error: switch back`,
          type: 'is-danger',
          title: 'Error',
          onConfirm: this.switchTo(null, false),
        });
      } finally {
        this.$store.commit(MUTATIONS.SET_SPLASH, false);
      }
    },

    async mergeLeads() {
      const valid = await this.$refs.mergeObserver.validate();
      if (valid) {
        this.mergeForm.leadId1 = this.mergeForm.leadId1.trim();
        this.mergeForm.leadId2 = this.mergeForm.leadId2.trim();
        this.preloader(true);
        try {
          const { data } = await mergeLeads(this.mergeForm);
          this.errorContent = '<p style="margin-bottom: 15px">Leads were merged successfully.</p>'
            + `<p><span style="font-size: 18px">View main lead in <a class="close-link notification-group-ref" href="https://app.close.com/lead/${data.id}" target="_blank">Close</a></span></p>`;
          this.isErrorActive = true;
          this.clearMergeLead();
        } catch (e) {
          if (e.response) {
            const error = get(e, 'response.data.message');
            const detail = JSON.parse(get(e, 'response.data.detail', '{}'));
            const doubleLead = get(detail, 'slave');
            const masterLead = get(detail, 'master');
            if (error === '[Internal] Banned Double Lead') {
              this.errorContent = `<div>
                        <div class="modern-dialog-body">
                          <div><i class="fa fa-exclamation-circle"></i></div>
                          <div>
                              <p>Merging is blocked:</p>
                              <p>double lead with status [Internal] Banned.</p>
                          </div>
                        </div>
                        <span style="margin-top: 15px; font-size: 18px">View double lead in <a class="close-link notification-group-ref" href="https://app.close.com/lead/${doubleLead}" target="_blank">Close</a></span>
                       </div>
                       `;
              this.isErrorActive = true;
            } else if (error === 'Lead ID not found.') {
              if (this.$refs[detail.name] !== undefined) {
                this.$refs[detail.name].setErrors(['Lead ID not found.']);
              }
              return;
            } else {
              this.errorContent = `<div>
                        <div class="modern-dialog-body">
                          <div><i class="fa fa-exclamation-circle"></i></div>
                          <div>
                              <p>Leads were not fully merged:</p>
                              <p>sorry, something went wrong. Connect to support.</p>
                          </div>
                        </div>
                        <span style="margin-top: 15px; font-size: 18px">View main lead in <a class="close-link notification-group-ref" href="https://app.close.com/lead/${masterLead}" target="_blank">Close</a></span>
                       </div>`;
              this.isErrorActive = true;
            }
          }
        } finally {
          this.preloader(false);
        }
      }
    },

    clearMergeLead() {
      this.isMergeFormActive = false;
      setTimeout(() => {
        this.mergeForm.leadId1 = null;
        this.mergeForm.leadId2 = null;
      }, 300);
    },

    async newLead() {
      this.preloader(true);
      const leadSources = await getLeadSources();
      const leadFirstTouch = await getLeadFirstTouch(true);
      const manager = await getManager({ email: this.userAuthEmail });
      const businessTypes = await getBusinessTypes();
      const businessSpecializations = await getSpecializations();
      const LeadComponent = Vue.extend(Lead);
      const leadModal = await this.$buefy.modal.open({
        parent: this,
        props: {
          leadFirstTouches: this.getTransformedLTF(leadFirstTouch.data.data),
          leadSources: this.getTransformedArray(leadSources.data.data),
          leadOwner: manager.data?.firstName ? `${manager.data.firstName} ${manager.data.lastName}` : '',
          businessTypes: businessTypes.data.data,
          businessSpecializations: businessSpecializations.data.data,
          customerTypes: this.customerTypes,
          active: true,
        },
        events: {
          submit: (value) => {
            leadModal.close();
            const messsage = '<div style="font-size: 20px">Lead was created successfully.</div>';
            const viewLeadLink = `<div style="font-size: 18px; margin-top: 2em">View lead in <a class="close-link notification-group-ref" href="https://app.close.com/lead/${value.id}" target="_blank">Close</a>`;
            this.showNotify(messsage + viewLeadLink);
          },
          error: ({ data }) => {
            const errorMessage = '<div style="font-size: 20px"><%= message %>: <b style="font-size: 18px"><%= errorValue %></b></div>';
            const viewLeadLink = '<div style="font-size: 18px; margin-top: 2em">View lead in <a class="close-link notification-group-ref" href="https://app.close.com/lead/<%= leadSource %>" target="_blank">Close</a>';
            const errorTemplate = template(errorMessage + (get(data, 'detail.leadSource') ? viewLeadLink : ''));

            // format telephone number
            if (data.error === 'validation_error_duplicate_phone') {
              set(data, 'detail.errorValue', get(data, 'detail.errorValue', '')
                .replace(/\+?1(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
            }
            leadModal.close();
            this.showNotify(get(data, 'detail') ? errorTemplate(data.detail) : data.message, true);
          },
        },
        component: LeadComponent,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
      });
      this.changeModalPosition();
      this.preloader(false);
    },

    showNotify(message, isDanger = false) {
      const NotificationComponent = Vue.extend(Notification);
      this.$buefy.modal.open({
        parent: this,
        props: {
          headerTitle: 'Lead info',
          isDanger,
          content: message,
        },
        component: NotificationComponent,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['escape', 'button'],
      });
    },

    changeModalPosition() {
      const grid = document.querySelector('.grid-module');
      const modal = document.querySelector('.modal');
      if (grid && modal) grid.insertAdjacentElement('beforeend', modal);
    },

    getTransformedLTF(array) {
      if (array.length !== 0) {
        return array.map((item) => ({
          id: item.id,
          sourceId: item.sourceId,
          name: item.value,
        }));
      }
      return array;
    },

    getTransformedArray(array) {
      if (array.length !== 0) {
        return array.map((item) => ({
          id: item.id,
          sourceId: item.sourceId,
          name: item.value,
          linkId: item.linkId,
        }));
      }
      return array;
    },

    createAccount(row) {
      this.currentEditRow = row;
      this.$buefy.dialog.confirm({
        message: `Name: <b>${row.firstName} ${row.lastName}</b><br />
        Email: <b>${row.email}</b><br />
        Plan: <b>${row.plan ? row.plan.name : null}</b>`,
        confirmText: 'Create',
        type: 'is-success',
        cancelText: 'CANCEL',
        title: 'Do you want to create new account?',
        onConfirm: () => {
          this.preloader(true);
          createUser({
            email: row.email,
            firstname: row.firstName,
            lastname: row.lastName,
            plan: row.plan ? row.plan.id : null,
            manager: this.$store.state.user.id,
          })
            .then((response) => {
              this.$buefy.toast.open({
                type: 'is-success',
                message: 'Account successfully created. An email with an authorization '
                  + 'link has been sent to the contractor.',
                duration: 3000,
              });
              this.currentEditRow.hasUser = true;
              this.currentEditRow.user = get(response, 'data.id', null);

              this.$set(this.data, this.data.indexOf(row), this.currentEditRow);
            })
            .catch((error) => {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: this.lodash.get(error, 'response.data.message', 'Undefined error'),
                duration: 3000,
              });
            })
            .finally(() => { this.currentEditRow = null; this.preloader(false); });
        },
      });
    },

    sendConfirmEmail(rowData) {
      this.currentEditRow = rowData;
      this.$buefy.dialog.confirm({
        message: `An email with an activation link will be sent to <b>${rowData.email}</b>`,
        confirmText: 'RESEND',
        type: 'is-success',
        cancelText: 'CANCEL',
        title: 'Resend activation link',
        onConfirm: () => {
          this.preloader(true);
          confirmAccount(this.currentEditRow.user)
            .then((response) => {
              this.$buefy.toast.open({
                type: 'is-success',
                message: response.data.message,
                duration: 3000,
              });
            })
            .catch((error) => {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: this.lodash.get(error, 'response.data.message', 'Undefined error'),
                duration: 3000,
              });
            })
            .finally(() => { this.preloader(false); });
        },
      });
    },

    editCustomer(rowData) {
      const currentCustomer = { ...rowData, w9: this.extractW9Options(rowData) };
      this.currentEditRow = currentCustomer;
      const Component = Vue.extend(CustomerForm);
      const modal = new Component({
        propsData: {
          active: true,
          contractor: currentCustomer,
          customerTypes: this.customerTypes,
        },
      });
      modal.$store = this.$store;
      modal.$mount();
      modal.$on('submit', (data) => {
        const idx = this.data.indexOf(this.data.filter((row) => row.id === data.id).pop());
        // todo: зачем менять this.data если потом идет search?
        this.$set(this.data, idx, { ...this.data[idx], ...data });
        this.$refs.module.removeChild(modal.$el);
        this.search();
      });
      modal.$on('close', () => {
        this.$refs.module.removeChild(modal.$el);
      });
      this.$refs.module.appendChild(modal.$el);
    },

    openW9Form(record) {
      const entity = { ...record, w9: this.extractW9Options(record) };
      const Component = Vue.extend(W9TaxForm);
      const modal = new Component({
        propsData: {
          entityId: entity.id,
          entityType: 'contractor',
          active: true,
          taxClassificationIsChecked: 0,
          openExistW9: 1,
          entity,
        },
      });

      modal.$store = this.$store;
      modal.$mount();
      modal.$on('submit', (response) => {
        if (response) {
          this.$refs.module.removeChild(modal.$el);
          this.search(false);
        }
      });
      modal.$on('close', () => {
        this.$refs.module.removeChild(modal.$el);
      });
      this.$refs.module.appendChild(modal.$el);
    },

    sort(field, order) {
      this.filters.sortField = field;
      this.filters.sortOrder = order;
    },

    needRenderTypeColumnBusinessTypeValue(row) {
      const customerType = this.get(row, 'type.value');
      const businessType = this.get(row, 'businessType.type');

      return businessType
        && (
          (customerType === 'Contractor' && businessType !== 'Contractor Business')
          || (customerType === 'Medical' && businessType !== 'Medical')
        );
    },
  },
};
</script>

<template>
<div class="enhancify grid-module" ref="module">
  <div class="columns">
    <div class="column is-2 btn-flex sm-show" style="display: none; min-width: 180px; gap: .75em">
      <b-button
        v-if="authAuthenticator({ resource: 'manage-contractors', code: 'lead_create' })"
        class="button-right modern-button "
        type="outlined"
        position="is-right"
        style="max-width: 160px; width: 160px; margin-top: .75em; flex-grow: 1"
        @click="newLead">
        NEW LEAD
      </b-button>
      <b-button
        v-if="authAuthenticator({ resource: 'manage-contractors', code: 'lead_merge' })"
        class="button-right modern-button"
        type="outlined"
        position="is-right"
        style="max-width: 160px; width: 160px; margin-top: .75em; flex-grow: 1"
        @click="isMergeFormActive = true">
        MERGE LEADS
      </b-button>
    </div>
    <div class="column">
      <form id="usersFilter" @submit.prevent.stop="clearPageSearch">
        <section class="modern-form-group">
        <div class="modern-input-controlled">
          <ModernInput  placeholder="Search..."
                        name="searchText"
                        v-model="filters.searchText"
                        type="search"/>
          <div class="modern-input-control">
            <button class="modern-button" type="submit">
              <i class="mdi mdi-magnify"></i>
            </button>
          </div>
        </div>

        <div class="modern-input-labeled">
          <label for="paymentStatus" style="white-space: nowrap">Type</label>
          <ModernSelect
              id="type"
              name="type"
              v-model="filters.typeId"
              optionLabelKey="value"
              optionValueKey="id"
              :options="customerTypeOptions"
          />
        </div>

        <div class="modern-input-labeled">
          <label for="paymentStatus" style="white-space: nowrap">Payment Status</label>
          <ModernSelect
            id="paymentStatus"
            name="paymentStatus"
            v-model="filters.statusPayment"
            :options="paymentStatusOptions"
          />
        </div>
        <div class="modern-input-labeled">
          <label for="w9" style="white-space: nowrap">W-9</label>
          <ModernSelectBox
            id="w9"
            name="w9"
            style="width: 13em"
            v-model="filters.statusW9"
            :options="w9Options">
            <template #options-footer>
              <hr style="margin: .5em">
              <b-checkbox form="usersFilter"
                          :native-value="true"
                          v-model="filters.showDifferencesOnly"
                          name="isDifferencesOnly"
                          style="padding: 2px 1em 2px 1em">
                Show differences only
              </b-checkbox>
            </template>
          </ModernSelectBox>
        </div>
        <div class="modern-input-labeled">
          <label for="tier" style="white-space: nowrap">Tier</label>
          <ModernSelect
            id="tier"
            name="tier"
            v-model="filters.tier"
            :options="tierOptions"
          />
        </div>
        <div class="modern-input-labeled">
          <label for="CPActivation" style="white-space: nowrap">CP activation</label>
          <ModernSelect
            id="CPActivation"
            name="cpActivation"
            v-model="filters.cpActivation"
            :options="cpActivationOptions"
          />
        </div>
      </section>
      </form>
    </div>
    <div class="column is-one-third btn-flex sm-hide"
         style="align-content: start; min-width: 180px; gap: .75em">
      <b-button
        v-if="authAuthenticator({ resource: 'manage-contractors', code: 'lead_create' })"
        class="button-right modern-button "
        type="outlined"
        position="is-right"
        style="max-width: 160px; width: 160px; margin-top: .75em; flex-grow: 1"
        @click="newLead">
        NEW LEAD
      </b-button>
      <b-button
        v-if="authAuthenticator({ resource: 'manage-contractors', code: 'lead_merge' })"
        class="button-right modern-button"
        type="outlined"
        position="is-right"
        style="max-width: 160px; width: 160px; margin-top: .75em; flex-grow: 1"
        @click="isMergeFormActive = true">
        MERGE LEADS
      </b-button>
    </div>
  </div>
  <section class="data-grid" >
    <template v-if="!data.length">
      <b-table
        class="modern-table"
        height="100%"
        :columns="columns"
        :loading="loading"
      >
        <template #header="{ column }">
          <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
         'modern-table-header-label']">
            {{ column['label'] }}
            <template v-if="column['meta']">
              <reports-table-tooltip :content="column['meta']" />
            </template>
          </div>
        </template>

        <template #empty v-if="!loading">
          <div style="padding-top: 1em; overflow: hidden; text-align: center">
          <span class="icon">
            <i class="fal fa-frown fa-3x"></i>
          </span>
            <p>Nothing here</p>
          </div>
        </template>
      </b-table>
    </template>
    <template v-else>
      <ModernTable
        ref="table"
        class="modern-table"
        height="100%"
        :loading="loading"
        :per-page="filters.limit"
        :total="total"
        :current-page.sync="filters.page"
        :data="data"
        paginated
        hoverable
        pagination-size="is-medium"
        backend-pagination
        backend-sorting
        :defaultSort="'hasUser'"
        @sort="sort"
      >

        <template #header="{ column }">
          <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
         'modern-table-header-label']"
               :ref="column['field']">
            {{ column['label'] }}
            <template v-if="column['meta']">
              <reports-table-tooltip :content="column['meta']" />
            </template>
          </div>
        </template>

        <template #default="{ row }">
          <b-table-column label="Switch to"
                          headerClass="switch-to-header"
                          field="hasUser"
                          width="100"
                          sortable
                          centered
                          sticky>
            <b-switch v-if="row['hasUser']"
                      :value="row['user'] === userId"
                      size="is-small"
                      type="is-success"
                      class="enh-switch"
                      @input="switchTo(row['user'], $event)" />
          </b-table-column>
          <b-table-column label="Company name"
                          headerClass="company-name-header"
                          field="companyName" width="300"
                          style="background: #f2f5f6" sticky sortable
                          :class="{sticked: isLeftSticky}" cellClass='company-name-column'>
            {{ row['companyName'] }}
          </b-table-column>
          <b-table-column field="firstName" label="First name" width="250" sortable>
            {{ row['firstName'] }}
          </b-table-column>
          <b-table-column field="lastName" label="Last name" width="250" sortable>
            {{ row['lastName'] }}
          </b-table-column>
          <b-table-column field="email" label="E-mail" width="450" sortable>
            <span style="white-space: nowrap">
              <i class="fas fa-envelope has-text-success" style="margin-right: .3em" />
              <span style="white-space: break-spaces">{{ row['email'] | lower | trim }}</span>
            </span>
          </b-table-column>
          <b-table-column field="phoneNumber" label="Phone number" width="170" sortable>
          <span>
            <i class="pb-10 fas fa-rotate-90 fa-phone has-text-success" />
            {{ row['phone'] | phone }}
          </span>
          </b-table-column>
          <b-table-column field="contractorPlan" label="Plan" width="320" sortable>
            {{ row['plan'] ? row['plan']['name'] : null }}
          </b-table-column>
          <b-table-column field="registrationDate"
                          label="Registration date" width="190" sortable centered>
            {{ row['date'] | dateFormat }}
          </b-table-column>
          <b-table-column field="cpActivation" label="CP activation" width="190" sortable centered>
            <template v-if="get(row, 'cpActivation.error')">
              <span style="color: red; cursor: pointer"
                    :title="cpActivationTitle(row)">
                Error
              </span>
            </template>
            <template v-else>
              <span :title="cpActivationTitle(row)">
                {{ get(row, 'cpActivation.date') | dateFormat }}
              </span>
            </template>
          </b-table-column>

          <b-table-column field="type" label="Type" width="190" sortable :meta="help.type">

            <template>
              <reports-table-tooltip
                  v-if="windowWidth < 769"
                  placement="auto"
                  :content="help['type']"
              />
              <span :class="[{
                  'report-table__value_fixed': windowWidth < 769
                }]">
                <span>
                  <template v-if="get(row, 'type.value')">
                      {{ row.type.value }}

                    <template v-if="needRenderTypeColumnBusinessTypeValue(row)">
                      <br>
                      <span style="font-size: 14px; color: #BB8282;">
                        {{ row.businessType.type }}
                      </span>
                    </template>
                  </template>
                </span>
                </span>
            </template>
          </b-table-column>

          <b-table-column field="lead" label="Lead" width="550" sortable>
            <a :href="`https://app.close.com/lead/${row['leadId']}`" target="_blank">{{ row['leadId'] }}</a>
          </b-table-column>
          <b-table-column field="paymentStatus" label="Payment Status" width="150" sortable>
            {{ row['paymentStatus'] }}
          </b-table-column>
          <b-table-column label="W-9" width="160" sortable field="w9">
          <span v-if="row['hasUser']" :class="{
            'w9-success': w9Status(row) === 'Verified',
            'w9-danger': w9Status(row) === 'Rejected',
            'w9-info': w9Status(row) === 'Pending'
          }">
            <a  :class="{
            'w9-success': w9Status(row) === 'Verified',
            'w9-danger': w9Status(row) === 'Rejected',
            'w9-info': w9Status(row) === 'Pending'
          }" v-if="w9Status(row)"
                @click="openW9Form(row)">
              {{ w9Status(row) }}
            </a>
            <span v-else>Not Found</span>
            <i v-if="w9Status(row)
                 && row['w9Tax'].isDifferent && !row['w9Tax'].skipDifferences"
               class="mdi mdi-alert-circle mdi-24px has-text-danger"></i>
          </span>
          </b-table-column>
          <b-table-column field="contractorId" label="Customer ID" width="160" centered sortable>
            {{ row['id'] }}
          </b-table-column>
          <b-table-column width="150" centered>
            <div class="table-controll">
              <button title="Create account"
                      v-if="isCreateAccountAvailable(row)"
                      class="button control-button" @click="createAccount(row)">
                <span class="icon">
                  <i class="fas fa-user-plus has-text-success"></i>
                </span>
              </button>
              <button title="Resend activation link"
                      v-if="isSendConfirmEmailAvailable(row)"
                      class="button control-button" @click="sendConfirmEmail(row)">
                  <span class="icon">
                    <i class="fas fa-envelope has-text-success"></i>
                  </span>
              </button>
              <button title="Edit customer"
                      class="button control-button" @click="editCustomer(row)">
                  <span class="icon">
                    <i class="fas fa-pencil-alt has-text-success"></i>
                  </span>
              </button>
            </div>
          </b-table-column>
        </template>

        <template #bottom-left>

          <div class="modern-input-labeled">
            <label class="per-page" for="paymentStatus"
                   style="font-weight: 700; white-space: nowrap">
              Per page
            </label>
            <ModernSelect
              style="margin-right: 1em"
              v-model="filters.limit"
              :options="perPageOptions"
            />
          </div>
        </template>

        <template #empty v-if="!loading">
          <div style="padding-top: 1em; overflow: hidden; text-align: center">
          <span class="icon">
            <i class="fal fa-frown fa-3x"></i>
          </span>
            <p>Nothing here</p>
          </div>
        </template>
        <template #test>

        </template>
      </ModernTable>
    </template>
  </section>

  <b-modal  :active="isMergeFormActive" :canCancel="false">
    <div class="modern-card modal-card">
      <header class="modern-card__header">Merge leads
        <b-button class="modern-card__close-button" aria-label="close" icon-right="close"
                  @click="clearMergeLead" />
      </header>
      <section class="modern-card__body">
        <p class="text-tip">
          Enter the IDs of the leads whose data you want to merge. The main and duplicate leads will
          be identified automatically.
          <b-tooltip :label="`The duplicate lead data, such as custom fields, contacts, about lead,
                      and tasks, will be transferred into the main lead's data. After that,
                      we will discard contacts for the duplicate lead and mark the lead
                      as &quot;Double&quot;. The duplicate lead won't be
                      deleted after it's merged.`"
                     class="block-tooltip is-gray"
                     type="is-info"
                     size="is-medium"
                     position="is-bottom"
                     :delay="200"
                     animated
                     multilined>
            <b-icon pack="fa" size="is-small" icon="question-circle">
            </b-icon>
          </b-tooltip>
        </p>
        <validation-observer ref="mergeObserver">
          <form class="modern-modal-form">
            <validation-provider v-slot="{ errors }"
                                 ref="leadId1"
                                 :rules="{ 'required': true}">
              <b-field label="Lead ID 1"
                       :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input name="leadId1" v-model.trim="mergeForm.leadId1" />
              </b-field>
            </validation-provider>
            <validation-provider v-slot="{ errors }"
                               ref="leadId2"
                               :rules="{ 'required': true, 'is_not': mergeForm.leadId1 }">
            <b-field label="Lead ID 2" name="leadId2" :type="{ 'is-danger': errors.length }">
              <b-input v-model.trim="mergeForm.leadId2" />
            </b-field>
            <p class="help is-danger" v-for="(error, key) in errors" :key="key">
              <template v-if="error === '{field} is not valid'">
                Lead IDs do match.
              </template>
              <template v-else-if="error === 'Lead ID not found.'">
                Lead ID not found.
              </template>
              <template v-else>
                This field is required.
              </template>
            </p>
            </validation-provider>
          </form>
        </validation-observer>
      </section>
      <footer class="modern-card__footer">
        <button type="button" class="button is-success outlined"
                  @click="clearMergeLead">Cancel</button>
        <button type="button" class="button is-success"
                  @click="mergeLeads">MERGE</button>
      </footer>
    </div>
  </b-modal>
  <b-modal  :active="isErrorActive" :canCancel="false">
    <div class="modern-card modal-card">
      <header class="modern-card__header">Lead info
        <b-button class="modern-card__close-button" icon-right="close"
                  @click="isErrorActive = false; errorContent = ''; " />
      </header>
      <section class="modern-card__body modern-card__body_round ">
        <div v-html="errorContent"></div>
      </section>
    </div>
  </b-modal>
</div>
</template>

<style scoped lang="stylus">

@require "../../../assets/style/modern/variables.styl";

::v-deep .notification-group-ref
  padding-right 10px
  color #525F66
  font-weight bold
  position relative
::v-deep .notification-group-ref::before
  content url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='14' cy='14' r='13.5' fill='white' stroke='%23525F66'/%3E%3Cpath d='M20.3536 14.3536C20.5488 14.1583 20.5488 13.8417 20.3536 13.6464L17.1716 10.4645C16.9763 10.2692 16.6597 10.2692 16.4645 10.4645C16.2692 10.6597 16.2692 10.9763 16.4645 11.1716L19.2929 14L16.4645 16.8284C16.2692 17.0237 16.2692 17.3403 16.4645 17.5355C16.6597 17.7308 16.9763 17.7308 17.1716 17.5355L20.3536 14.3536ZM7 14.5H20V13.5H7V14.5Z' fill='%23525F66'/%3E%3C/svg%3E")
  position absolute
  top -3px
  right -25px
::v-deep .notification-group-ref:hover::before
  content url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='14' cy='14' r='13.5' fill='%23525F66' stroke='%23525F66'/%3E%3Cpath d='M20.3536 14.3536C20.5488 14.1583 20.5488 13.8417 20.3536 13.6464L17.1716 10.4645C16.9763 10.2692 16.6597 10.2692 16.4645 10.4645C16.2692 10.6597 16.2692 10.9763 16.4645 11.1716L19.2929 14L16.4645 16.8284C16.2692 17.0237 16.2692 17.3403 16.4645 17.5355C16.6597 17.7308 16.9763 17.7308 17.1716 17.5355L20.3536 14.3536ZM7 14.5H20V13.5H7V14.5Z' fill='white'/%3E%3C/svg%3E")

::v-deep .modern-arrow
  color #525f66
  font-size 1.7em
  vertical-align middle

.text-tip
  font-size .8em
::v-deep .modern-card__body .label
  font-weight 400

.modern-card__footer
  .button
    min-width 135px
.button.button-cancel
  text-transform uppercase
  border-color #23D160
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white

.help-text
  color #969ea2

::v-deep .b-table.is-loading:after
  z-index 10

footer.modal-card-foot
  padding 12px
  justify-content end

::v-deep .enh-switch input[type=checkbox]:checked + .check.is-success
  background #68ba62

::v-deep .modal .animation-content .modal-card
  margin 0 auto

::v-deep .enh-switch:hover input[type=checkbox]:checked + .check.is-green
  background #17b548

@media (max-width: $breakpoints.md)
  ::v-deep .modern-table
    td::before
      padding-right 1.5em !important
      white-space nowrap
  .tooltip-icon-container
    margin-left: -1.2em
  .report-table__value_fixed
    margin-left auto
  ::v-deep .level-left
    .modern-input-labeled
      justify-content center
    .modern-select
      flex-grow unset !important
      max-width 120px

@media (max-width: $breakpoints.md)
  .modern-input-controlled
    padding-top 0
  .modern-input-labeled, .modern-input-controlled
    margin-right 0
  .sm-hide
    display none !important
  .sm-show
    display flex !important

.btn-flex
  display: flex;
  justify-content: end
  @media screen and (max-width: $breakpoints.md)
    width 100%
    justify-content: end
    .modern-button
      max-width 160px;


.w9-success
  color green
.w9-danger
  color #8b0000
.w9-info
  color #1e90ff

::v-deep .modal-close
  opacity 1
::v-deep th
  height 102px
::v-deep .switch-to-header
  left 0 !important

::v-deep .fixed-header .company-name-header
  left 100px !important

::v-deep .company-name-header, .company-name-column
  left 100px !important

::v-deep .company-name-header
  min-width 300px

::v-deep table th.company-name-header.is-sticky, ::v-deep table th.switch-to-header.is-sticky
  z-index 9 !important

td
  min-width 140px

.switch-to-header
  .modern-table-header-label
    margin-right unset

::v-deep .switch-to-header .icon
    margin-left .1em !important

td[data-label="First name"], td[data-label="Last name"]
  overflow-wrap anywhere
  white-space normal

td[data-label="Phone number"]
  white-space nowrap !important
  overflow-wrap unset

.per-page:after
  content: ''

.data-grid
  padding-bottom 2em

.control-button
  margin 0
  background transparent
  border none
  font-size 24px
  padding 0

.floating-button
  margin-left auto
  margin-right 0

.table-controll
  display flex
  justify-content end
  gap 1em
  button
    width 36px
    height 36px !important
  .icon
    font-size 24px
    i
      color #68ba62 !important
      &:hover
        color #17b548 !important
</style>
